const Storage = {
  isAuthenticated: function (data) {
    const userData = Storage.getUserData();
    if (userData) return true;
    return false;
  },
  setUserData: function (data) {
    localStorage.setItem("user_data", JSON.stringify(data));
  },
  getUserData: function () {
    const user = JSON.parse(localStorage.getItem("user_data"));
    return user !== null ? user : null;
  },
  deleteUserData: function () {
    localStorage.removeItem("user_data");
  },
  getUserToken: function () {
    return JSON.parse(localStorage.getItem("user_data"));
  },
  getTheme: function () {
    return localStorage.getItem("theme");
  },
  setTheme: function (color) {
    localStorage.setItem("theme", color);
  },
  getFeatures: function () {
    const features = JSON.stringify(localStorage.getItem("features"));

    if (typeof features === "object") {
      return features;
    }
    return [];
  },
  getLastLocation: function () {
    return JSON.parse(localStorage.getItem("last_location"));
  },
  setLastLocation: function (data) {
    localStorage.setItem("last_location", JSON.stringify(data));
  },
  isAuthenticated: function () {
    const userData = Storage.getUserData();
    
    if(!userData){
      window.location = "/";
    }
  }
};

export default Storage;
